import React from "react";
import styles from "./OfferActions.module.css";
import {OfferInListDTO, OfferSource, OfferStatus} from "../../../../../../../api/generated";
import {FormName, openForm} from "../../../../../../elements/formProvider/formSlice";
import {openPopupModal, PopupModalName} from "../../../../../../elements/popupModalProvider/popupModalSlice";
import {useAppDispatch} from "../../../../../../../app/hooks";
import {EditButton} from "../../../../../../elements/editButton/EditButton";
import {ArchiveButton} from "../../../../../../elements/archiveButton/ArchiveButton";
import {showErrorToastNotification} from "../../../../../../elements/toastNotification/toastNotificationSlice";

interface ActionsProps {
    index: number
    offer: OfferInListDTO
}

export const OfferActions: React.FC<ActionsProps> = ({
                                                         index,
                                                         offer
                                                     }) => {

    const dispatch = useAppDispatch()

    const handleEditClick = () => {
        dispatch(openForm({
            name: FormName.UPDATE_OFFER,
            formProps: {
                publicId: offer.publicId,
                publicBotId: offer.publicBotId,
                publicLocationId: offer.publicLocationId
            }
        }))
    }

    const handleArchiveClick = () => {
        const newOfferStatus = offer.offerStatus === OfferStatus.Active ? OfferStatus.Archived : OfferStatus.Active

        if (newOfferStatus === OfferStatus.Active && new Date(offer.endDate) < new Date()) {
            dispatch(showErrorToastNotification({message: "You can't unarchive the offer, because it's end date is in the past"}))
            return
        }

        const yesButtonTitle = newOfferStatus === OfferStatus.Active ? "unarchive" : "archive"
        const title = newOfferStatus === OfferStatus.Active ? "Unarchive the offer" : "Archive the offer"
        const subtitle = newOfferStatus === OfferStatus.Active ? "Are you sure you want to unarchive this offer? Unactive offer will be visible to customers again." : "Are you sure you want to archive this offer? Archived offer will not be visible to customers."
        dispatch(
            openPopupModal({
                name: PopupModalName.CHANGE_OFFER_STATUS,
                popupModalProps: {
                    offer,
                    newOfferStatus,
                    title,
                    subtitle,
                    yesButtonTitle
                }
            })
        )
    }

    return <div key={index} className={styles.wrapper}>
        <EditButton disabled={offer.offerSource !== OfferSource.Manual} handleClick={handleEditClick}/>
        <ArchiveButton handleClick={handleArchiveClick}/>
    </div>
}
